import { render, staticRenderFns } from "./ActionFormPreview.vue?vue&type=template&id=745ff572&"
import script from "./ActionFormPreview.vue?vue&type=script&lang=js&"
export * from "./ActionFormPreview.vue?vue&type=script&lang=js&"
import style0 from "./ActionFormPreview.vue?vue&type=style&index=0&id=745ff572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports